import _definePage_default_0 from '/github/workspace/src/pages/dashboard.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/github/workspace/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/admin-documentation',
    name: '/adminDocumentation',
    component: () => import('/github/workspace/src/pages/adminDocumentation.vue'),
    /* no children */
    meta: {
      "requiresFullAdmin": true
    }
  },
  {
    path: '/compass',
    name: '/compass',
    component: () => import('/github/workspace/src/pages/compass.vue'),
    /* no children */
    meta: {
      "requiresCompass": true
    }
  },
  _mergeRouteRecord(
  {
    path: '/dashboard',
    name: '/dashboard',
    component: () => import('/github/workspace/src/pages/dashboard.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/feedback',
    name: '/feedback',
    component: () => import('/github/workspace/src/pages/feedback.vue'),
    /* no children */
  },
  {
    path: '/help',
    name: '/help',
    component: () => import('/github/workspace/src/pages/help.vue'),
    /* no children */
  },
  {
    path: '/incomplete-timesheets',
    name: '/incompleteTimeEntries',
    component: () => import('/github/workspace/src/pages/incompleteTimeEntries.vue'),
    /* no children */
    meta: {
      "requiresAdmin": true
    }
  },
  {
    path: '/leave',
    name: '/Leave',
    component: () => import('/github/workspace/src/pages/Leave.vue'),
    /* no children */
    meta: {
      "requiresAdmin": true
    }
  },
  {
    path: '/organogram',
    name: '/organogram',
    component: () => import('/github/workspace/src/pages/organogram.vue'),
    /* no children */
  },
  {
    path: '/outlook-signature',
    name: '/outlookSignature',
    component: () => import('/github/workspace/src/pages/outlookSignature.vue'),
    /* no children */
  },
  {
    path: '/project-intake',
    name: '/projectIntake',
    component: () => import('/github/workspace/src/pages/projectIntake.vue'),
    /* no children */
    meta: {
      "requiresProjectIntake": true
    }
  },
  {
    path: '/projects',
    name: '/projects',
    component: () => import('/github/workspace/src/pages/projects.vue'),
    /* no children */
  },
  {
    path: '/projects/:id',
    name: '/projectDetail',
    component: () => import('/github/workspace/src/pages/projectDetail.vue'),
    /* no children */
  },
  {
    path: '/Timesheet',
    name: '/Timesheet',
    component: () => import('/github/workspace/src/pages/Timesheet.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

